import classNames from 'class-names';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { AccordionContext, useAccordionToggle } from 'react-bootstrap';

import { Icon } from '../../../Atoms/Icon';

export const ContextToggle = ({
  children,
  eventKey,
  iconPosition = 'left',
  className = 'border-0',
}) => {
  const activeEventKey = useContext(AccordionContext);

  const toggle = useAccordionToggle(eventKey);

  const icon = activeEventKey === eventKey ? 'chevron-down' : 'chevron-right';

  return (
    <button
      type="button"
      onClick={toggle}
      className={classNames(
        className,
        'd-flex align-items-center bg-white text-black',
      )}
    >
      {iconPosition === 'right' && children}
      <span className="px-2">
        <Icon className="small text-gray-600" name={icon} />
      </span>
      {iconPosition === 'left' && children}
    </button>
  );
};

ContextToggle.propTypes = {
  children: PropTypes.node.isRequired,
  eventKey: PropTypes.string.isRequired,
  className: PropTypes.string,
  iconPosition: PropTypes.oneOf(['left', 'right']),
};
